<template>
  <div>
    <v-container>
        <v-form ref="form" v-model="armaForm">
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <div class="text-subtitle-1">Tipo y clase</div>
                </v-col>
                <v-col>
                  <BaseInput
                    class="ui-form-field"
                    label="Número económico"
                    v-model.number="arma.noEconomico"
                    type="number"
                    min="0"
                  ></BaseInput>
                </v-col>
                <v-col>
                  <BaseSelect class="ui-form-field" v-model="selectedTipo" :items="tipoArma">
                    <template v-slot:label>Tipo de arma <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
                <v-col>
                  <BaseSelect
                    class="ui-form-field"
                    v-model="arma.fk_idClase"
                    :items="catalogoTipoArma"
                    :rules="required"
                  >
                    <template v-slot:label>Clase de arma <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
                <v-col>
                  <BaseSelect
                    class="ui-form-field"
                    label="Calibre"
                    v-model="arma.fk_idCalibre"
                    :items="calibre"
                    :rules="required"
                  >
                    <template v-slot:label>Calibre <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <div class="text-subtitle-1">Marca y modelo</div>
                </v-col>
                <v-col>
                  <BaseSelect
                    class="ui-form-field"
                    label="Marca"
                    v-model="selectedMarca"
                    :items="marcaArma"
                    @change="fetchModeloArmas($event)"
                  >
                    <template v-slot:label>Marca <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
                <v-col>
                  <BaseSelect
                    class="ui-form-field"
                    label="Modelo"
                    v-model="arma.fk_idModelo"
                    :items="catalogoModeloArma"
                    :rules="required"
                  >
                    <template v-slot:label>Modelo <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="6">
                  <BaseInput class="ui-form-field" label="Matrícula" v-model="arma.matricula"></BaseInput>
                </v-col>
                <v-col cols="6">
                  <BaseSelect
                    class="ui-form-field"
                    v-model="arma.fk_idCatProcedenciaArma"
                    :items="procedencia"
                    :rules="required"
                  >
                    <template v-slot:label>Procedencia <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
                <v-col cols="4">
                  <BaseInput class="ui-form-field" label="Folio C" v-model="arma.folioC"></BaseInput>
                </v-col>
                <v-col cols="4">
                  <BaseInput class="ui-form-field" label="Folio D" v-model="arma.folioD"></BaseInput>
                </v-col>
                <v-col cols="4">
                  <BaseInput class="ui-form-field" label="Ubicación" v-model="arma.armeros"></BaseInput>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <BaseInput
                    class="ui-form-field"
                    v-model="arma.fechaAltaLoc"
                    v-mask="'##/##/####'"
                    hint="Formato de fecha: DD/MM/YYYY"
                    :rules="dateRules"
                  >
                    <template v-slot:label>Fecha de alta en LOC <span class="red--text">*</span> </template>
                  </BaseInput>
                </v-col>
                <v-col cols="4">
                  <BaseInput
                    class="ui-form-field"
                    v-model="arma.fechaCompra"
                    v-mask="'##/##/####'"
                    hint="Formato de fecha: DD/MM/YYYY"
                    :rules="dateRules"
                  >
                    <template v-slot:label>Fecha de compra <span class="red--text">*</span> </template>
                  </BaseInput>
                </v-col>
                <v-col cols="4">
                  <BaseInput
                    class="ui-form-field"
                    v-model="arma.puestaDisposición"
                    v-mask="'##/##/####'"
                    hint="Formato de fecha: DD/MM/YYYY"
                    :rules="dateRules"
                  >
                    <template v-slot:label>Fecha de puesta a disposición <span class="red--text">*</span> </template>
                  </BaseInput>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
    </v-container>
    <div class="d-flex justify-center mt-2">
      <TextButton
        class="ui-module-btn-solid"
        @click="triggerSaveArma()"
        :loading="loading"
        :disabled="!armaForm || loading"
      >
        Registrar arma
      </TextButton>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import BaseSelect from '../../../base/BaseSelect.vue'
import BaseInput from '../../../base/BaseInput.vue'
import TextButton from '../../../base/TextButton.vue'

export default {
  components: {
    BaseSelect,
    BaseInput,
    TextButton,
  },
  data() {
    return {
      registroArmaDialog: false,
      loading: false,
      armaForm: false,

      arma: {
        serie: '',
        folio: '',
        matricula: '',
        noEconomico: 0,
        folioC: '',
        folioD: '',
        loc: '',
        fechaAltaLoc: '',
        fk_idSubsede: null,
        armeros: '',
        fk_idModelo: null,
        fk_idClase: null,
        fk_idCalibre: null,
        fk_idEstatus: null,
        fk_idCatProcedenciaArma: null,
        cantidadCargadores: 0,
        fechaCompra: null,
        puestaDisposición: null,
      },

      selectedTipo: null,
      selectedMarca: null,

      required: [(v) => !!v || 'Este campo es requerido.'],

      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, this.API_DATE_FORMAT)
          return moment(date, this.API_DATE_FORMAT).isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
    }
  },

  computed: {
    ...mapGetters('tipoArma', {
      tipoArma: 'getTipoArmas',
    }),

    ...mapGetters('claseArma', {
      claseArmaCorta: 'getClasesArmaCorta',
      claseArmaLarga: 'getClasesArmaLarga',
    }),

    ...mapGetters('marcaArma', {
      marcaArma: 'getMarcaArma',
    }),

    ...mapGetters('marcaArma', {
      marcaArma: 'getMarcaArma',
    }),

    ...mapGetters('modeloArma', {
      modeloArma: 'getModelosArmas',
      catalogoModeloArma: 'getCatalogoModeloArma',
    }),

    ...mapGetters('calibre', {
      calibre: 'getCalibres',
    }),

    ...mapGetters('estatusArma', {
      estatus: 'getEstatusArma',
    }),

    ...mapGetters('procedencia', {
      procedencia: 'getProcedencia',
    }),

    ...mapGetters('subsede', {
      subsede: 'getSubsedes',
    }),

    filteredClaseArma: function () {
      if (this.selectedTipo) {
        if (this.selectedTipo == 1) {
          return this.claseArmaLarga
        } else return this.claseArmaCorta
      } else return []
    },
    catalogoTipoArma: function () {
      return this.filteredClaseArma.map((tipo) => ({
        id: tipo.id,
        title: tipo.clase,
      }))
    },
  },

  methods: {
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapActions('arma', ['saveArma', 'fetchArmas']),

    closeDialog() {
      this.registroArmaDialog = false

      this.arma = {
        serie: '',
        folio: '',
        matricula: '',
        noEconomico: 0,
        folioC: '',
        folioD: '',
        loc: '',
        fechaAltaLoc: '',
        fk_idSubsede: null,
        armeros: '',
        fk_idModelo: null,
        fk_idClase: null,
        fk_idCalibre: null,
        fk_idEstatus: null,
        fk_idCatProcedenciaArma: null,
        cantidadCargadores: 0,
      }

      this.selectedTipo = null
      this.selectedMarca = null
      this.loading = false
      this.$refs.form.resetValidation()
    },

    async triggerSaveArma() {
      this.loading = true
      await this.saveArma(this.arma)
      await this.fetchArmas()
      this.loading = false
      this.$emit('close')
      this.closeDialog()
    },
  },
}
</script>

<style scoped>
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

::v-deep .ui-form-field .v-input__slot,
::v-deep .v-text-field .v-input__slot,
::v-deep .v-select .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover,
::v-deep .v-text-field .v-input__slot:hover,
::v-deep .v-select .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control,
::v-deep .v-text-field .v-input__control,
::v-deep .v-select .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control,
::v-deep .v-text-field.v-input--is-focused .v-input__control,
::v-deep .v-select.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .v-label,
::v-deep .v-text-field input,
::v-deep .v-select .v-select__selection,
::v-deep .v-label {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .v-text-field .v-label,
::v-deep .v-select .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .v-text-field.v-input--is-focused .v-label,
::v-deep .v-select.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

::v-deep .ui-module-btn-solid.v-btn {
  background-color: var(--v-secondary-base) !important;
  border-radius: 14px !important;
  text-transform: none !important;
  font-weight: 700 !important;
}

::v-deep .ui-module-btn-solid.v-btn.v-btn--disabled {
  background-color: var(--v-secondary-base) !important;
  opacity: 0.5 !important;
}
</style>
